"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var configuration_1 = require("./configuration");

var apron_back_splash_1 = require("./apron-back-splash");

var assembly_accessories_1 = require("./assembly-accessories");

var built_in_parts_1 = require("./built-in-parts");

var drain_accessories_1 = require("./drain-accessories");

var selected_trough_1 = require("./selected-trough");

var surface_1 = require("./surface");

var wash_basin_dimension_1 = require("./wash-basin-dimension");

exports.resolveConfigurationData = function (props) {
  var configuration = {};
  var configurationDefaults = {};
  var keys = Object.keys(configuration_1.ConfigurationKeys);
  var conf = new configuration_1.Configuration(props.configuration); // Forcing taps there for the defaults population

  if (conf.plateBuilder) {
    conf.plateBuilder.components = conf.plateBuilder.populateWithConfOverrides({}, {
      forceRenderTaps: true,
      forceRenderSoapDispensers: true
    });
  }

  keys.forEach(function (objectKey, index) {
    var previousObjectKey = keys[index - 1];
    var prevKey = previousObjectKey && configuration_1.ConfigurationKeys[previousObjectKey];
    var key = configuration_1.ConfigurationKeys[objectKey];

    switch (key) {
      case configuration_1.ConfigurationKeys.ApronBackSplash:
        var apronBackSplash = new apron_back_splash_1.ApronBackSplash(props, conf.plateBuilder);
        apronBackSplash.setKey = key;

        if (props.configuration[key] && prevKey) {
          apronBackSplash.setPrevKey = prevKey;
        }

        configurationDefaults[key] = apronBackSplash.handleDefaults();
        configuration[key] = props.configuration[key] && apronBackSplash.handle() || null;
        break;

      case configuration_1.ConfigurationKeys.AssemblyAccessories:
        var assemblyAccessories = new assembly_accessories_1.AssemblyAccessories(props, conf.plateBuilder);
        assemblyAccessories.setKey = key;

        if (props.configuration[key] && prevKey) {
          assemblyAccessories.setPrevKey = prevKey;
        }

        configurationDefaults[key] = assemblyAccessories.handleDefaults();
        configuration[key] = props.configuration[key] && assemblyAccessories.handle() || null;
        break;

      case configuration_1.ConfigurationKeys.BuiltInParts:
        var builtInParts = new built_in_parts_1.BuiltInParts(props, conf.plateBuilder);
        builtInParts.setKey = key;

        if (props.configuration[key] && prevKey) {
          builtInParts.setPrevKey = prevKey;
        }

        configurationDefaults[key] = builtInParts.handleDefaults();
        configuration[key] = props.configuration[key] && builtInParts.handle() || null;
        break;

      case configuration_1.ConfigurationKeys.DrainAccessories:
        var drainAccessories = new drain_accessories_1.DrainAccessories(props, conf.plateBuilder);
        drainAccessories.setKey = key;

        if (props.configuration[key] && prevKey) {
          drainAccessories.setPrevKey = prevKey;
        }

        configurationDefaults[key] = drainAccessories.handleDefaults();
        configuration[key] = props.configuration[key] && drainAccessories.handle() || null;
        break;

      case configuration_1.ConfigurationKeys.SelectedTrough:
        var selectedTrough = new selected_trough_1.SelectedTrough(props, conf.plateBuilder);
        selectedTrough.setKey = key;

        if (props.configuration[key] && prevKey) {
          selectedTrough.setPrevKey = prevKey;
        }

        configurationDefaults[key] = selectedTrough.handleDefaults();
        configuration[key] = props.configuration[key] && selectedTrough.handle() || null;
        break;

      case configuration_1.ConfigurationKeys.Surface:
        var surface = new surface_1.Surface(props, conf.plateBuilder);
        surface.setKey = key;

        if (props.configuration[key] && prevKey) {
          surface.setPrevKey = prevKey;
        }

        configurationDefaults[key] = surface.handleDefaults();
        configuration[key] = props.configuration[key] && surface.handle() || null;
        break;

      case configuration_1.ConfigurationKeys.WashBasinDimension:
        var washBasinDimension = new wash_basin_dimension_1.WashBasinDimension(props, conf.plateBuilder);
        washBasinDimension.setKey = key;

        if (prevKey) {
          washBasinDimension.setPrevKey = prevKey;
        }

        configurationDefaults[key] = washBasinDimension.handleDefaults();
        configuration[key] = washBasinDimension.handle() || null;
        break;

      default:
        return;
    }
  });
  return {
    configuration: configuration,
    defaults: configurationDefaults
  };
};